export { updateLoginAnnouncementsData, mapLoginAnnouncementsPayloadToGqlInput } from './login-announcements-update';
